import type React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { styled } from 'styled-components';

import Button from '../../Controls/Button/index.tsx';

const Div = styled.div`
  text-align: center;
  margin-top: 15px;
`;

export interface IInfiniteTable {
  next: () => React.ReactNode | void | Promise<void>;
  hasMore: boolean;
  loading: boolean;
  children: React.ReactNode;
  scrollableTarget?: HTMLElement | string | null;
  className?: string;
  dataLength: number;
  loadMoreLabel: string;
  scrollThreshold?: number;
  overflow?: boolean;
}

const InfiniteScrollComponent: React.FC<IInfiniteTable> = ({
  next,
  hasMore,
  loading,
  children,
  dataLength,
  loadMoreLabel,
  scrollThreshold = 0.6,
  scrollableTarget,
}) => (
  <InfiniteScroll
    next={next}
    hasMore={hasMore}
    loader={<span />}
    scrollThreshold={scrollThreshold}
    // Wrong type in the package: https://github.com/ankeetmaini/react-infinite-scroll-component/issues/378
    scrollableTarget={scrollableTarget as unknown as React.ReactNode}
    dataLength={dataLength}
    style={{
      overflow: 'visible',
    }}>
    {children}
    {hasMore && (
      <Div>
        <Button disabled={loading} isLoading={loading} onClick={next} variant='create-secondary' inline>
          {loadMoreLabel}
        </Button>
      </Div>
    )}
  </InfiniteScroll>
);

export default InfiniteScrollComponent;
